import React, { useState } from "react";
import CourseFile from "../../CourseFileUpload";
import TextEditor from "./TextEditor";

export const CourseSection = ({
  current,
  index,
  section,
  handleInputChange,
  handleEditorStateChange,
  courseFile,
  removeFormFields,
  history,
  location,
  isCurrentFileUpload,
  isCurrentFileUploadStatus,
}) => {
  const [isActive, setIsActive] = useState(false);
  const handleAddCourseMaterial = (event) => {
    event.preventDefault();
    setIsActive((state) => !state);
  };

  return (
    <div className="course-section" key={index}>
      <div className="section-introduction">
        <h4>Section {index + 1} - Title</h4>
        <div className="form-inline">
          <input
            type="text"
            name="courseSections"
            placeholder={`Add section ${index + 1} title`}
            value={section?.name}
            onChange={({ target }) =>
              handleInputChange(index, target.name, target.value, "name", true)
            }
          />
        </div>

        {(current === 18 || location === "courseEdit") && (
          <div className="section-description">
            <h4>Section {index + 1} - Description</h4>
            <TextEditor
              formState={section?.description}
              history={history}
              handleEditorStateChange={handleEditorStateChange(
                "courseSections",
                "description",
                index
              )}
            />
          </div>
        )}
        {location === "createBundle" && (
          <div className="section-description">
            <h4>Section {index + 1} - Description</h4>
            <TextEditor
              formState={section?.description}
              history={history}
              handleEditorStateChange={handleEditorStateChange(
                "courseSections",
                "description",
                index
              )}
            />
          </div>
        )}

        <div className="form-inline section-description">
          <h4>Section {index + 1} - Video/Document Link</h4>
          <input
            type="text"
            name="courseSections"
            placeholder="Video/Document Link"
            value={section?.videoLink}
            onChange={({ target }) =>
              handleInputChange(
                index,
                target.name,
                target.value,
                "videoLink",
                true
              )
            }
          />
        </div>
        <div className="define-add-text">
          <a
            name={index}
            href="javascript(void);"
            onClick={handleAddCourseMaterial}
          >
            + Add Course material
          </a>
        </div>
        {isActive && (
          <div className="chapter-section">
            <div className="course-image-introductionSection">
              <CourseFile
                courseFileLimit={5}
                courseFile={courseFile}
                isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                isCurrentFileUpload={isCurrentFileUpload}
                courseId={
                  history.location.state ? history.location.state.courseId : 0
                }
              />
            </div>
          </div>
        )}
      </div>
      <div id="align-image">
        {index > 0 ? (
          <img
            name="courseSections"
            href="javascript(void);"
            className=""
            onClick={(event) =>
              removeFormFields(event, index, event.target.name)
            }
            src="https://cdn.edusity.com/icons/icon-trash.svg"
            alt=""
          />
        ) : null}
      </div>
    </div>
  );
};
